import { Loader } from "components";
import { MatchingComonProfil } from 'components/ComonProfil';
import { injectIntl } from "react-intl";
import { MatchingActioner } from "services/matching";
import { TimelineActioner } from "services/timeline";
import { VolunteerActioner } from "services/volunteer";

function VolunteerAllTimelineComponent(props) {
  const { id } = props;

  function renderPage(matchs, timelines) {
    return <MatchingComonProfil matchs={matchs} timelines={timelines} displayCampaign={true} />;
  }

  function render(render){
    VolunteerActioner.get(id).then((volunteer) => {
        Promise.all([MatchingActioner.getVolunteerMatchingByUuid(volunteer.uuid), TimelineActioner.getVolunteerTimelineByUuid(volunteer.uuid)]).then(
          ([matchs, timelines]) => {
            render(renderPage(matchs, timelines));
          }
        );
    });
  }


  return <Loader render={render} />;
}

const VolunteerAllTimeline = injectIntl(VolunteerAllTimelineComponent);

export { VolunteerAllTimeline };
